var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_420_7741)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3692 12.5303C10.6621 12.2374 10.6621 11.7626 10.3692 11.4697L4.48008 5.58058C4.18718 5.28769 4.18718 4.81282 4.48008 4.51992L4.83363 4.16637C5.12652 3.87348 5.6014 3.87348 5.89429 4.16637L11.7834 10.0555C12.0763 10.3483 12.5511 10.3483 12.844 10.0555L18.7331 4.16636C19.026 3.87347 19.5009 3.87347 19.7938 4.16636L20.1473 4.51992C20.4402 4.81281 20.4402 5.28768 20.1473 5.58058L14.2583 11.4697C13.9654 11.7626 13.9654 12.2374 14.2583 12.5303L20.1473 18.4194C20.4402 18.7123 20.4402 19.1872 20.1473 19.4801L19.7938 19.8336C19.5009 20.1265 19.026 20.1265 18.7331 19.8336L12.844 13.9445C12.5511 13.6517 12.0763 13.6517 11.7834 13.9445L5.89429 19.8336C5.6014 20.1265 5.12652 20.1265 4.83363 19.8336L4.48008 19.4801C4.18718 19.1872 4.18718 18.7123 4.48008 18.4194L10.3692 12.5303Z",
    fill: "#3B5118"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_420_7741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconclose);
export default __webpack_public_path__ + "static/media/icon.close.214dcb9354a9a0e4f702459cddfb2a0b.svg";
export { ForwardRef as ReactComponent };